export const languages = [
  { code: 'en-US', name: 'English' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'en-AU', name: 'English (Australia)' },
  { code: 'en-CA', name: 'English (Canada)' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'es-ES', name: 'Español (España)' },
  { code: 'es-MX', name: 'Español (México)' },
  { code: 'fr-FR', name: 'Français' },
  { code: 'fr-CA', name: 'Français (Canada)' },
  { code: 'de-DE', name: 'Deutsch' },
  { code: 'zh-CN', name: '中文 (简体)' }, // Simplified Chinese
  { code: 'zh-TW', name: '中文 (繁體)' }, // Traditional Chinese
  { code: 'ja-JP', name: '日本語' }, // Japanese
  { code: 'ko-KR', name: '한국어' }, // Korean
  { code: 'it-IT', name: 'Italiano' },
  { code: 'pt-BR', name: 'Português (Brasil)' },
  { code: 'pt-PT', name: 'Português (Portugal)' },
  { code: 'ar-SA', name: 'العربية' }, // Arabic
  { code: 'hi-IN', name: 'हिन्दी' }, // Hindi
  { code: 'ru-RU', name: 'Русский' }, // Russian
  { code: 'nl-NL', name: 'Nederlands' }, // Dutch
  { code: 'sv-SE', name: 'Svenska' }, // Swedish
  { code: 'fi-FI', name: 'Suomi' }, // Finnish
  { code: 'da-DK', name: 'Dansk' }, // Danish
  { code: 'no-NO', name: 'Norsk' }, // Norwegian
  { code: 'pl-PL', name: 'Polski' }, // Polish
  { code: 'tr-TR', name: 'Türkçe' }, // Turkish
  { code: 'th-TH', name: 'ไทย' }, // Thai
  { code: 'vi-VN', name: 'Tiếng Việt' }, // Vietnamese
  { code: 'km-KH', name: 'ខ្មែរ' }, // Khmer (Cambodian)
  { code: 'ms-MY', name: 'Bahasa Malaysia' }, // Malay
  { code: 'id-ID', name: 'Bahasa Indonesia' } // Indonesian
];
